import { render, staticRenderFns } from "./StudentProfileTab.vue?vue&type=template&id=bfb90f06&"
import script from "./StudentProfileTab.vue?vue&type=script&lang=js&"
export * from "./StudentProfileTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports